<template>
  <div class="organizedKeyVideo" ref="organizedKeyVideo">
    <!-- <div class="lookAllVideo">查看全部</div> -->
    <div class="videoList">
      <div class="everyVideo" v-for="i in 9" :key="i">
        <!-- <video :src="videoName(i)"></video> -->
        <video
          :id="'myPlayer-' + i + '-' + curTime"
          :ref="'myPlayer-' + i + '-' + curTime"
          class="centeredVideo"
          controls
          muted
          autoplay
          width="1024"
          height="776"
        >
          Your browser is too old which doesn't support HTML5 video.
        </video>
        <!--video controls loop autoplay muted>
          <source :src="videoName(i)" type="video/mp4">
          暂无视频
        </video-->
        <!-- <p>暂无视频</p> -->
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { getCurrentInstance, onUnmounted } from "vue";
import flvjs from "flv-h265.js";
import axios from "axios";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      hlvList: [],
      player: {},
      flvPlayer: {},
      keepAliveTimer: null,
      axiosEasyNvr: null,
      curTime: new Date().getTime(),
    };
  },
  setup() {
    const { proxy } = getCurrentInstance(); // 获取当前组件实例
    const ctx = proxy;

    onUnmounted(() => {
      // ...
      ctx.flv_destroy();
    });
  },
  //计算属性 类似于data概念
  computed: {
    videoName() {
      return function (i) {
        try {
          let _url = "/static/video/video" + i + ".mp4";
          return _url;
        } catch (err) {
          console.log(err);
        }
      };
    },
  },
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.axiosEasyNvr = axios.create({
      timeout: 60000,
      baseURL: "/",
      headers: {
        "Content-Type": "text/html",
        "Content-Type": "application/xhtml+xml",
        "Content-Type": "application/xml",
      },
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.organizedKeyVideo).outerWidth();
    let h = $(that.$refs.organizedKeyVideo).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });

    this.curTime = new Date().getTime();
    this.getChannelStream();
  },
  //方法集合
  methods: {
    async getChannelStream() {
      let that = this;
      let getUrl = "/api/v1/getchannels";

      this.axiosEasyNvr
        .get(getUrl, {
          params: {},
        })
        .then((res) => {
          if (res.data.EasyDarwin.Header.ErrorNum == 200) {
            //rtmpUrl = this.videoBaseUrl + res.data.EasyDarwin.Body.URL;
            //console.log("rtmpUrl", rtmpUrl);
            //this.videoUrl = rtmpUrl;
            //播放视频
            //this.initVideo();
            let Channels = res.data.EasyDarwin.Body.Channels;
            if (Channels && Channels.length > 0) {
              for (let i = 0; i < Channels.length; i++) {
                that.getVideoUrl(Channels[i], i);
              }
            }
          } else {
            rtmpUrl = "";
          }
        });
    },
    getVideoUrl(tmpObj, n) {
      let that = this;
      let ts = new Date().getTime();
      let getUrl =
        "/api/v1/getchannelstream?channel=" +
        tmpObj["Channel"] +
        "&protocol=HTTP-FLV&_=" +
        ts;
      that.axiosEasyNvr
        .get(getUrl, {
          params: { token: window.easyAxiosToken },
        })
        .then((res) => {
          if (res.data.EasyDarwin.Header.ErrorNum == 200) {
            let flvUrl = res.data.EasyDarwin.Body.URL;
            //that.hlvList.push(flvUrl);
            that.initVideo(flvUrl, n + 1);
          }
        });
    },
    initVideo(flvUrl, Channel) {
      let that = this;
      this.curChannel = Channel;
      this.player[Channel] = this.$refs["myPlayer-" + Channel + "-" + this.curTime];
      if (flvjs.isSupported()) {
        this.flvPlayer[Channel] = flvjs.createPlayer(
          {
            type: "flv",
            isLive: true, //<====加个这个
            //url: "ws://localhost:10800/ws/flv/hls/stream_" + channel + ".flv", //<==自行修改
            url:
              (bmeConfig.easyNvrUrl ? bmeConfig.easyNvrUrl : "http://localhost:10800") +
              flvUrl,
            duration: 0,
          },
          {
            enableStashBuffer: false,
            isLive: true,
            lazyLoad: false,
            lazyLoadMaxDuration: 0,
            lazyLoadRecoverDuration: 0,
            deferLoadAfterSourceOpen: false,
            fixAudioTimestampGap: false,
          }
        );
        this.flvPlayer[Channel].attachMediaElement(this.player[Channel]);
        this.flvPlayer[Channel].load(); //加载
        if (this.flvPlayer[Channel].flvTimer) {
          clearInterval(this.flvPlayer[Channel].flvTimer);
        }
        this.flvPlayer[Channel].flvTimer = setInterval(() => {
          if (!that.flvPlayer[Channel].buffered.length) {
            return;
          }
          let end = that.flvPlayer[Channel].buffered.end(0);
          let diff = end - that.flvPlayer[Channel].currentTime;
          if (diff >= 1.5) {
            that.flvPlayer[Channel].currentTime = end - 0.1;
          }
        }, 3 * 10 * 1000);
        if (this.keepAliveTimer) {
          clearTimeout(this.keepAliveTimer);
        }
        this.keepAliveTimer = setTimeout(function () {
          that.keepFlvAlive(Channel);
        }, 30 * 1000);
      }
    },
    keepFlvAlive(Channel) {
      let that = this;
      let ts = new Date().getTime();
      let getUrl =
        "/api/v1/touchchannelstream?channel=" + Channel + "&protocol=HTTP-FLV&_=" + ts;
      axios.get(getUrl, {
        params: { token: window.easyAxiosToken },
      });
      if (this.keepAliveTimer) {
        clearTimeout(this.keepAliveTimer);
      }
      this.keepAliveTimer = setTimeout(function () {
        that.keepFlvAlive(Channel);
      }, 30 * 1000);
    },
    flv_destroy() {
      if (this.keepAliveTimer) {
        clearTimeout(this.keepAliveTimer);
      }
      try {
        for (let i in this.flvPlayer) {
          if (this.flvPlayer[i].flvTimer) {
            clearInterval(this.flvPlayer[i].flvTimer);
          }
        }

        for (let i in this.player) {
          if (this.player[i]) {
            this.player[i].pause();
            this.player[i].unload();
            this.player[i].detachMediaElement();
            this.player[i].destroy();
            this.player[i] = null;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  /*activated() {
    this.curTime = new Date().getTime();
    this.getChannelStream();
  }, //如果页面有keep-alive缓存功能，这个函数会触发
  beforeUnmount() {
    debugger;
    this.flv_destroy();
  },
  deactivated() {
    debugger;
    this.flv_destroy();
  },*/
  beforeRouteLeave(to, from, next) {
    // debugger;
  },
};
</script>
<style lang="scss" scoped="scoped">
.organizedKeyVideo {
  width: 1229px;
  height: 790px;
  padding-top: 10px !important;
  // .lookAllVideo {
  //   cursor: pointer;
  //   width: 152px;
  //   height: 47px;
  //   background: #00ffa7;
  //   border-radius: 6px;
  //   width: 122px;
  //   font-size: 28px;
  //   font-weight: 500;
  //   color: #080808;
  //   line-height: 47px;
  //   text-align: center;
  //   position: absolute;
  //   top: -6px;
  //   right: 39px;
  // }
  .videoList {
    margin: 42px auto 0px;
    //background-color: #45616ca6;
    margin-top: 42px;
    // height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    .everyVideo {
      width: 390px;
      height: 225px;
      margin: 5px 0px;
      //border: 1px solid #000;
      p {
        display: block;
        text-align: center;
        font-size: 25px;
        line-height: 221px;
      }
    }
  }
}
</style>
